import HttpService from './HttpService';

export default class PaymentLinkService extends HttpService {
    endPoint = "/v1/payments/link"

    manageActivation(id) {
        return new HttpService().getAuthTokenRequest()
            .patch("/v1/payments/link/manage-activation/" + id);
    }
}
